import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/img/cross.svg'


const _hoisted_1 = { class: "opModal formContainer" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "body" }
const _hoisted_7 = { class: "row mt-4" }
const _hoisted_8 = { class: "col-sm-12" }
const _hoisted_9 = {
  key: 0,
  class: "form-group"
}
const _hoisted_10 = ["label"]
const _hoisted_11 = ["value"]
const _hoisted_12 = {
  key: 1,
  class: "form-group"
}
const _hoisted_13 = { class: "form-control" }
const _hoisted_14 = {
  key: 0,
  class: "row"
}
const _hoisted_15 = { class: "col-sm-12" }
const _hoisted_16 = {
  key: 1,
  class: "row"
}
const _hoisted_17 = { class: "col-sm-12" }
const _hoisted_18 = {
  key: 2,
  class: "d-flex align-items-start justify-content-between mt-4 mb-5"
}
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = { class: "text-center mt-3" }
const _hoisted_23 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_form_field = _resolveComponent("form-field")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_localized_text, {
          localizedKey: "Add Production Process",
          text: "Add Production Process"
        })
      ]),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-modal-close",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
      }, _hoisted_5)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          (!_ctx.productionProcessName)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createVNode(_component_localized_text, {
                  type: "label",
                  localizedKey: "Production Process",
                  text: "Production Process"
                }),
                _withDirectives(_createElementVNode("select", {
                  class: "form-control",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.model.productionProcessIdentifier) = $event)),
                  onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.checkTypeOfProcess()))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.filteredAllProductionProcesses as any), (value, key, i) => {
                    return (_openBlock(), _createElementBlock("optgroup", {
                      key: key,
                      label: key ? key.toString() : 'Single items'
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(value, (item, i) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: i,
                          value: item.identifier
                        }, _toDisplayString(item.text), 9, _hoisted_11))
                      }), 128))
                    ], 8, _hoisted_10))
                  }), 128))
                ], 544), [
                  [_vModelSelect, _ctx.model.productionProcessIdentifier]
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createVNode(_component_localized_text, {
                  type: "label",
                  localizedKey: "Production Process",
                  text: "Production Process"
                }),
                _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.productionProcessName), 1)
              ]))
        ])
      ]),
      (_ctx.liquidPolymerAndTechniqueSelected != null)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_component_form_field, {
                type: "select-string",
                labelKey: "Liquid Polymer",
                labelValue: "Liquid Polymer",
                placeholderKey: "Liquid Polymer",
                placeholderValue: "Liquid Polymer",
                list: _ctx.liquidPolymerAndTechniqueSelected.emissionCalculation.liquidPolymer.map(x => x.key),
                modelValue: _ctx.selectedLiquidPolymerKey,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedLiquidPolymerKey) = $event)),
                class: "w-100"
              }, null, 8, ["list", "modelValue"]),
              _createVNode(_component_form_field, {
                type: "select-string",
                labelKey: "Technique",
                labelValue: "Technique",
                placeholderKey: "Technique",
                placeholderValue: "Technique",
                list: _ctx.liquidPolymerAndTechniqueSelected.emissionCalculation.technique.map(x => x.key),
                modelValue: _ctx.selectedTechniqueKey,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedTechniqueKey) = $event)),
                class: "w-100"
              }, null, 8, ["list", "modelValue"])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.processSelectedHasCustomField)
        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createVNode(_component_form_field, {
                type: "number",
                labelKey: "Custom amount",
                labelValue: "Custom amount",
                afterText: _ctx.isStitchingTimeSelected ? ' (minutes)' : '',
                placeholderKey: "Custom amount",
                placeholderValue: "Custom amount",
                modelValue: _ctx.model.customAmount,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.model.customAmount) = $event)),
                class: "w-100"
              }, null, 8, ["afterText", "modelValue"])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.model.productionProcessIdentifier && !_ctx.hideMaterialsSelection)
        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredRawMaterials, (rawMaterial) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "text-center mx-4",
                key: rawMaterial.identifier
              }, [
                _createElementVNode("strong", null, _toDisplayString(rawMaterial.text), 1),
                (_ctx.model.rawMaterialCountryAndUnits[rawMaterial.identifier])
                  ? (_openBlock(), _createElementBlock("p", _hoisted_19, _toDisplayString(_ctx.countries.filter(x => x.identifier == _ctx.model.rawMaterialCountryAndUnits[rawMaterial.identifier].key)[0].text), 1))
                  : (_openBlock(), _createElementBlock("p", _hoisted_20, "---")),
                _createElementVNode("div", {
                  class: _normalizeClass(["sameAsCheckbox pointer mx-auto mt-2", { active: Object.keys(_ctx.model.rawMaterialCountryAndUnits).indexOf(rawMaterial.identifier) != -1 }]),
                  onClick: ($event: any) => (_ctx.addOrRemoveRawMaterial(rawMaterial.identifier))
                }, null, 10, _hoisted_21)
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_22, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-tertiary",
          disabled: _ctx.disabled,
          onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)))
        }, [
          _createVNode(_component_localized_text, {
            localizedKey: "Create",
            text: "Create"
          })
        ], 8, _hoisted_23)
      ])
    ])
  ]))
}